function sendEventToDataLayer(event){
    window.dataLayer.push(event);
}

export default sendEventToDataLayer;